import React from 'react';
import { BaseCard } from './BaseCard';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'red' | 'transparent';
}

export const Card: React.FC<CardProps> = (props) => {
  return <BaseCard {...props} />;
};